// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { seclApi as seclApi } from '../apis/secl.api';

// action
import { actions } from '../actions/secl.action';

/**
 * PMT History 조회
 */
export const getSeclHistoryList = createAsyncThunk(
  actions.getSeclHistoryListAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await seclApi.getSeclHistoryList(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * PMT History  조회-벤더용
 */
export const getSeclHistoryListVendor = createAsyncThunk(
  actions.getSeclHistoryListVendorAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await seclApi.getSeclHistoryListVendor(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * PMT List 조회
 */
export const getSeclList = createAsyncThunk(
  actions.getSeclListAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await seclApi.getSeclList(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * PMT Save
 */
export const createSecl = createAsyncThunk(
  actions.createSeclAction,
  async (data, { dispatch, fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await seclApi.createSecl(data);

      if (!res) return;

      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
